var version = {
    "name":      "dativery",
    "buildDateCode": "20260317-151818",
    "buildDate": "Tue Mar 17 2026 15:18:18 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260317-151818",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;